import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import {Hint, HorizontalGridLines, VerticalBarSeries as BarSeries, VerticalGridLines, XAxis, XYPlot, YAxis,} from "react-vis/es/index";
import acc from 'accounting'
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";

export default class TrasowyChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ilevalue: null,
            wartvalue: null,
            daneTrasowyZnizki: [],
            daneTrasowyGeneral: [],
            czyPokazacSzczegoly: true,
        };
        this._rememberValue = this._rememberValue.bind(this);
        this._forgetValue = this._forgetValue.bind(this);
    }

    componentWillReceiveProps(nextprops) {

        this.setState({
            daneTrasowyZnizki: nextprops.daneTrasowyZnizki,
            daneTrasowyGeneral: nextprops.daneTrasowyGeneral,
        })
    }

    _forgetValue(typ) {
        if (typ === 'ile') this.setState({ilevalue: null});
        else this.setState({wartvalue: null});
    }

    _rememberValue(value, typ) {
        if (typ === 'ile') this.setState({ilevalue: value});
        else this.setState({wartvalue: value});

    }

    renderHint(obj) {
        return (
            <div className="CHARTtooltip">
                <span className="tooltiptext">
                <div>Zniżka: {obj.rodz}</div>
                <div>Ilość: {obj.ile}</div>
                <div>Wartość: {acc.formatMoney(obj.wart)}</div>
                </span>
            </div>
        )
    }

    obliczSumeWTabeli(arr, key) {
        let suma = 0;
        for (let i = 0; i < arr.length; i++) {
            suma = suma + arr[i][key]
        }
        return suma
    }

    renderZnizkiLabels() {
        return (
            this.state.daneTrasowyZnizki.map((item, index) => {
                return <span className={'label label-ebus-default'}
                             style={{color: '#fff', background: item[0].kolor, marginRight: '5px'}}>{item[0].rodz}</span>
            })
        )
    }

    renderWLiscie(arr, znizka,naz_zniz, kolor) {
        return <div className={'renderowanaListaSzegolowRaportowBiletowychSprzedazy'}>
            <div>
                {
                    (znizka === 'OGÓŁEM') ?
                        <div style={{fontWeight: 'bold', fontSize:'16px'}}>OGÓŁEM</div>
                        :
                        <div><span className={'label label-ebus-default'} style={{background: kolor, color: '#fff'}}>{znizka}</span><span style={{marginLeft:'3px',fontSize:'10px', color:'grey',fontStyle:'italic'}}>{naz_zniz}</span></div>

                }
            </div>
            <div className={(znizka === 'OGÓŁEM') ? 'tabelaOgolem':''}>
                <BootstrapTable data={arr}
                                hover
                >
                    <TableHeaderColumn dataField='idKi' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='naz_tr' dataSort
                                       thStyle={tabgrid.tg10} tdStyle={tabgrid.tg10}
                    ><i className={'fa fa-road'}></i> Trasa</TableHeaderColumn>
                    <TableHeaderColumn dataField='ile' dataSort
                                       thStyle={tabgrid.tg7} tdStyle={tabgrid.tg7}
                    ><i className={'fa fa-tags'}></i> Ilość</TableHeaderColumn>
                    <TableHeaderColumn dataField='wart' dataSort
                                       thStyle={tabgrid.tg8} tdStyle={tabgrid.tg8}
                                       dataFormat={(cell, row) => {
                                           return acc.formatMoney(cell)
                                       }}
                    ><i className={'fa fa-money'}></i> Wartość</TableHeaderColumn>
                </BootstrapTable>
            </div>
            <div className={'podsumowanieTr'}>
                <div className={'podsumowanieTd'} style={{width: '40%'}}>PODSUMOWANIE:</div>
                <div className={'podsumowanieTd'} style={{width: '28%'}}>{this.obliczSumeWTabeli(arr, 'ile')}</div>
                <div className={'podsumowanieTd'} style={{width: '32%'}}>{acc.formatMoney(this.obliczSumeWTabeli(arr, 'wart'))}</div>
            </div>
        </div>
    }

    render() {

        if(this.state.daneTrasowyGeneral.length == 0)
            return <TopAlertUwaga text={'Brak danych spełniających podane kryterium'}/>
        else
        return (
            <div style={{marginTop: '25px'}}>

                <div>
                    <div>
                        <h4 style={{textAlign: 'center'}}>Sprzedaż ilościowa na wszystkich trasach</h4>
                    </div>
                    <div>
                        <div className={'pull-right'} style={{margin: '5px'}}>
                            <span style={{marginRight: '5px'}}>Legenda zniżek: </span>
                            {this.renderZnizkiLabels()}
                        </div>
                        <div style={{height: '1px', clear: 'both'}}></div>
                    </div>
                    <div>
                        <XYPlot width={1600} height={400} stackBy="y" xType="ordinal" margin={{left: 50, bottom: 120}}>
                            <VerticalGridLines/>
                            <HorizontalGridLines/>
                            <XAxis tickLabelAngle={-60}/>
                            <YAxis title={'Ilość'}/>

                            {this.state.ilevalue ? <Hint value={this.state.ilevalue}>{this.renderHint(this.state.ilevalue)}</Hint> : null}

                            {
                                this.state.daneTrasowyZnizki.map((arr, index) => {
                                    return <BarSeries data={Array.from(arr, item => {
                                        return {...item, x: item.naz_tr, y: item.ile}
                                    })}
                                                      onValueMouseOver={(val) => this._rememberValue(val, 'ile')}
                                                      onValueMouseOut={() => this._forgetValue('ile')}
                                                      color={arr[0].kolor}
                                    />
                                })
                            }
                        </XYPlot>
                    </div>
                    <div>
                        <h4 style={{textAlign: 'center'}}>Sprzedaż wartościowa na wszystkich trasach</h4>
                    </div>
                    <div>
                        <XYPlot width={1600} height={400} stackBy="y" xType="ordinal" yType={'linear'} margin={{left: 50, bottom: 120}}>
                            <VerticalGridLines/>
                            <HorizontalGridLines/>
                            <XAxis tickLabelAngle={-60}/>
                            <YAxis title={'Wartość [zł]'}/>
                            {this.state.wartvalue ? <Hint value={this.state.wartvalue}>{this.renderHint(this.state.wartvalue)}</Hint> : null}
                            {
                                this.state.daneTrasowyZnizki.map((arr, index) => {
                                    return <BarSeries data={Array.from(arr, item => {
                                        return {...item, x: item.naz_tr, y: item.wart}
                                    })}
                                                      onValueMouseOver={(val) => this._rememberValue(val, 'wart')}
                                                      onValueMouseOut={() => this._forgetValue('wart')}
                                                      color={arr[0].kolor}
                                    />
                                })
                            }
                        </XYPlot>
                    </div>
                    <div>
                        <div className={'pull-right'}>
                            <TopButtonAction text={(this.state.czyPokazacSzczegoly) ? 'Ukryj szczegóły' : 'Pokaż szczegóły'}
                                             iconType={(this.state.czyPokazacSzczegoly) ? 'fa fa-eye-slash' : 'fa fa-eye'}
                                             onClick={() => this.setState({czyPokazacSzczegoly: !this.state.czyPokazacSzczegoly})}/>
                        </div>
                    </div>
                    <div style={{height: '1px', clear: 'both'}}></div>
                    <TopIf isTrue={this.state.czyPokazacSzczegoly}>
                        <div>
                            <Row>
                                <Col xs={6} lg={3}>
                                    {this.renderWLiscie(this.state.daneTrasowyGeneral, 'OGÓŁEM', '#000')}
                                </Col>
                                {
                                    this.state.daneTrasowyZnizki.map((arr, index) => {
                                        return <Col xs={6} lg={3}>{this.renderWLiscie(arr, arr[0].rodz,arr[0].naz_zniz, arr[0].kolor)}</Col>
                                    })
                                }
                            </Row>
                        </div>
                    </TopIf>
                </div>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazJednorazowych/components/TrasowyChart.js